import React from "react";
import styled, { withTheme } from "styled-components";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";

const StyledButton = styled(PrimaryButton)`
  width: 100%;
  margin-top: 5px;
`;

export const Button = (props) => {
  const { text, disabled, buttonDisabled = false } = props;
  return (
    <StyledButton
      type="submit"
      tabIndex="0"
      className="btn-md mt-1 mt-md-2 mt-xl-5 btn-auth"
      disabled={disabled || buttonDisabled}
    >
      {text}
    </StyledButton>
  );
};

export default withTheme(Button);
